<form [formGroup]="form" (ngSubmit)="submit()">
    <h2 mat-dialog-title>Make a reservation</h2>
    <mat-dialog-content>
        <div class="example-container" fxLayout="column">
            <mat-form-field>
                    <textarea matInput formControlName="description" placeholder="Short description of the planned event" required></textarea>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="start" type="date" placeholder="Start of event" required>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="end" type="date" placeholder="End of event">
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="mat-raised-button" mat-dialog-close>Close</button>
        <button mat-raised-button type="submit" color="primary">Submit</button>
    </mat-dialog-actions>
</form>